<template>
    <div class="action-item-wrap">
        <div class="header">
            <span class="delete" style="cursor: pointer" @click="handleDelete">
                <i class="el-icon-delete"></i>
                删除
            </span>
        </div>
        <!-- 选择是否作为结果输出 -->
        <el-checkbox v-model="value.asResult" style="margin-bottom: 10px;">作为结果</el-checkbox>
        <el-row style="display: flex; align-items: center; justify-content: space-between;">
            <el-col :span="6">
                <div class="action-label">标题:</div>
                <el-input @change="handleNameChange" size="mini" v-model="value.title" placeholder="请输入标题" />
            </el-col>
            <el-col :span="6">
                <div class="action-label">名称:</div>
                <el-input @change="handleNameChange" size="mini" v-model="value.name" placeholder="请输入名称" />
            </el-col>
            <el-col :span="6">
                <div class="action-label">类型:</div>
                <el-select :value="value.type" class="use-property" size="mini" placeholder="请选择类型"
                    @change="handlePropChange">
                    <el-option v-for="item in propOptions" :key="item.value" :label="item.label" size="mini"
                        :value="item.value"> </el-option>
                </el-select>
            </el-col>
            <el-col :span="6">
                <div class="action-label">描述:</div>
                <el-input type="textarea" @change="handleDefaultChange" size="mini" v-model="value.desc"
                placeholder="请输入描述" />
            </el-col>
        </el-row>
        <!-- 文本默认参考 -->
        <div v-if="value.type === 'text'">
            <div class="action-label">参考文本<span style="color: #333;">(换行隔开不同选项)</span>:</div>
            <el-input type="textarea" @change="handleDefaultChange" size="mini" v-model="value.textRef"
                placeholder="请输入默认值" />
        </div>

    </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: '',
          type: '',
          desc: ''
        }
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      propOptions: [
        {
          label: '文本',
          value: 'text'
        },
        {
          label: '图片',
          value: 'image'
        },
        {
          label: '语音',
          value: 'audio'
        },
        {
          label: '视频',
          value: 'video'
        },
        {
          label: '文件',
          value: 'file'
        }
      ]
    }
  },
  methods: {
    handleNameChange (value) {
      this.value.name = value
      this.$emit('change', this.value)
    },
    handlePropChange (value) {
      this.value.type = value
      this.$emit('change', this.value)
    },
    handleDelete () {
      this.$emit('delete')
    },
    handleDefaultChange (value) {
      this.value.desc = value
      this.$emit('change', this.value)
    }
  }
}
</script>
<style lang="less" scoped>
.action-item-wrap {
    background: #f3f6fa;
    border-radius: 4px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #303a51;
    line-height: 16px;
    font-weight: 400;
    padding: 9px 12px;
}

.header {
    // border-bottom: 1px solid #dcdfe6;
    margin-bottom: 8px;
    padding: 0 0 4px 0;
}

.delete {
    float: right;
    color: #a8adbd;
    font-weight: 400;
    &:hover {
        color: #2961ef;
    }
}

/deep/.el-col {
    display: flex;
}

/deep/.el-select {
    flex: 1;
}

.value-select {
    flex: 1;
}

.delete-button {
    height: 32px;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.action-label {
    margin-right: 10px;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    min-width: 30px;
    padding-left: 10px;
}
</style>
